import { set_token,set_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
    data() {
        return ({
        login_url :'',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        confirm_password: '',
        passwordVisible: false,
        confirmPasswordVisible: false,
        errors: {},
        passed: false,
        });
    },
    methods: {

    register_user() {
        this.validateForm();
            
        if (!this.passed) {
            return;
        }
        Swal.fire({
            title: 'Saving...',
            text: 'Please wait while we save the user data.',
            allowOutsideClick: false,
            showConfirmButton: false,
            onOpen: () => {
              Swal.showLoading();
            }
          });
        const protocol = window.location.protocol;
        const host = window.location.host;
        this.login_url = `${protocol}//${host}/sign_in_Finale`;
        $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/register_user/`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                "role":"user",
                "email":this.email,
                "last_name":this.last_name,
                "first_name":this.first_name,
                "phone_number":this.phone_number,
                "password":this.password,
                "login_url":this.login_url
            }),
            success: (response) => {    
                var status = response.status
                if(status == "success"){

                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Registration Successful',
                    }).then(() => {
                        var response_data = response.data;
                        set_token(response_data.token);
                        set_user_details(response_data.user_details);
                        const nextUrl = sessionStorage.getItem('next') || '/';
                        window.location = nextUrl;
                    });

                }
            },
            error: (response) => {
                Swal.close()
                var response_status = response.responseJSON
                if(response_status.status == 'error'){
                    var response_message=response_status.message.toLowerCase();

                    if (response_message.includes('email')) {
                        this.errors.email = response_message;

                    } else if (response_message.includes('phone number')) {
                        this.errors.phone_number =  response_message;
                    }
                }else{
                    this.validateForm()

                }
             
            }
        });
    },
    validateForm() {
        let valid = true;
        
        if (!this.first_name && this.first_name.length <= 3) {
            this.errors.first_name = 'First name is required';
            valid = false;
        } else {
            this.errors.first_name = '';
        }
        
        if (!this.last_name && this.first_name.length <= 3) {
            this.errors.last_name = 'Last name is required';
            valid = false;
        } else {
            this.errors.last_name = '';
        }
        
        if (!this.email) {
            this.errors.email = 'Email is required';
            valid = false;
        } else if (!this.isValidEmail(this.email)) {
            this.errors.email = 'Please enter a valid email';
            valid = false;
        } else {
            this.errors.email = '';
        }
        
        if (!this.phone_number) {
            this.errors.phone_number = 'Phone number is required';
            valid = false;
        } else if (/\s/.test(this.phone_number)) {
            this.errors.phone_number = 'Phone number should not contain spaces';
            valid = false;
        } else {
            this.errors.phone_number = '';
        }

        if (!this.password) {
            this.errors.password = 'Password is required';
            valid = false;
        } else if (!this.isValidPassword(this.password)) {
            this.errors.password = 'Password must be at least 8 characters, contain at least one uppercase letter, one lowercase letter, one digit, and one special character';
            valid = false;
        } else {
            this.errors.password = '';
        }

        if (!this.confirm_password) {
            this.errors.confirm_password = 'Confirm password is required';
            valid = false;
        } else if (this.password !== this.confirm_password) {
            this.errors.confirm_password = 'Passwords do not match';
            valid = false;
        } else {
            this.errors.confirm_password = '';
        }

        this.passed = valid;
    },
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    },
    isValidPhoneNumber(phone_number) {
        const re = /^[\d\-+()]+$/;
        return re.test(phone_number);
    },

    togglePasswordVisibility(field) {
        if (field === 'password') {
            this.passwordVisible = !this.passwordVisible;
        } else if (field === 'confirm') {
            this.confirmPasswordVisible = !this.confirmPasswordVisible;
        }
        },
        isValidPassword(password) {
            const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
            return re.test(password);
    },
 }
};



